import environment from '../../../environment';
import { NOTIFY_TYPE, notifyError, notifySuccess } from '../../../shared';
import fetch from '../../fetch';
import reducers from './reducers';

const LayerControls = (name) => require('../../../controls').get(name);

const poi = (() => {
    const _handleResponse = (message) => {
        if (LayerControls('PointOfInterest').check()) {
            LayerControls('PointOfInterest').getLayer().reset();
        }

        if (message.type === NOTIFY_TYPE.SUCCESS) {
            notifySuccess(message);
        } else {
            notifyError(message);
        }
    };

    const getPoi = (id) => {
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/pointOfInterest/${id}`,
            async: false
        }).then(reducers.poi, notifyError);
    };

    const add = req => {
        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Ponto criado com sucesso' };
            _handleResponse(message);
        };

        return fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/pointofinterest`,
            data: JSON.stringify(req),
            error: notifyError
        }).then(_success);
    };

    const update = req => {
        const _error = xhr => {
            _handleResponse(xhr);
        };

        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Ponto atualizado com sucesso' };
            _handleResponse(message);
        };

        return fetch({
            type: 'PUT',
            url: `${environment.get('API_HOST')}/pointofinterest`,
            data: JSON.stringify(req)
        }).then(_success, _error);
    };

    const remove = id => {
        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Ponto removido com sucesso' };
            _handleResponse(message);
        };

        return fetch({
            url: `${environment.get('API_HOST')}/pointofinterest/${id}`,
            type: 'DELETE'
        }).then(_success, notifyError);
    };

    return {
        getPoi,
        add,
        update,
        remove
    };
})();

export default poi;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/pointOfInterest/index.js